import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import MetricsStrip from "@/components/landing/MetricsStrip";
import Problem from "@/components/landing/Problem";
import WhatIs from "@/components/landing/WhatIs";
import Philosophy from "@/components/landing/Philosophy";
import Method from "@/components/landing/Method";
import Offer from "@/components/landing/Offer";
import Price from "@/components/landing/Price";
import WhoFor from "@/components/landing/WhoFor";
import Authority from "@/components/landing/Authority";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

/**
 * Landing page — Radiografía de Negocio · Enrique Torres / Mr. ET
 * Structure:
 *  1. Hero (video 01 — full-bleed background)
 *  2. MetricsStrip (5 floating cards: Tiempo / Ventas / Margen / Clientes / Procesos)
 *  3. Problem
 *  4. WhatIs ("Qué es la Radiografía")
 *  5. Philosophy (video 02 — blended)
 *  6. Method (video 03 — blended)
 *  7. Offer
 *  8. Who For
 *  9. Authority
 * 10. Final CTA
 * 11. Footer
 *
 * Edit content/links in /src/lib/content.js
 */
const Landing = () => {
  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen et-grain overflow-x-hidden"
      style={{ background: "#10202e" }}
    >
      <Navbar />
      <Hero />
      <MetricsStrip />
      <Problem />
      <WhatIs />
      <Philosophy />
      <Method />
      <Offer />
      <Price />
      <WhoFor />
      <Authority />
      <FinalCTA />
      <Footer />
    </main>
  );
};

export default Landing;
